import { render, staticRenderFns } from "./ed-dropdown.vue?vue&type=template&id=72449299&scoped=true&"
import script from "./ed-dropdown.ts?vue&type=script&lang=ts&"
export * from "./ed-dropdown.ts?vue&type=script&lang=ts&"
import style0 from "./ed-dropdown.scss?vue&type=style&index=0&id=72449299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72449299",
  null
  
)

export default component.exports